import { SecurityPageProps } from "models/security";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "redux/app/hooks";
import { addCelular } from "redux/features/cliente/cliente-slice";
import * as St from "./styles";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";
import ContainerFlex from "components/ContainerFlex";
import { RouteNames } from "routes/routes";
import { phoneMask } from "utils/mask";

const ClienteCelular: React.FC<SecurityPageProps> = ({
  title,
  description = "",
}) => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);
  const history = useHistory();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (input.length <= 11) {
      setValue(phoneMask(input).masked);
    }
  }, [input]);

  const handleSubmit = async () => {
    dispatch(addCelular(value));
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.HOME,
      backStep: RouteNames.HOME,
    };

    history.push({
      pathname: RouteNames.TERMO_E_CONDICOES,
      state: { ...propsRouter },
    });
  };

  const handleVoltar = () => {
    history.push(RouteNames.HOME);
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Peça o TeuCard</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Por favor, digite <span>teu Celular</span> e pressione a tecla verde
            <br />
            (ENTRA), para continuar a operação:
          </span>
        </St.Description>
      </ContainerFlex>
      <ContainerFlex center>
        <ContainerFlex width={60}>
          <ContainerFlex marginBottom={10}>
            <Input
              label="Valor"
              style={{
                height: "15%",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
              name="valorInfo"
              value={value}
              onChange={(e) => setValue(e)}
              edit
              disabled
            />
          </ContainerFlex>
          <KeyboardWrapper
            onPressBack={handleVoltar}
            keyboardRef={keyboard}
            onChange={setInput}
            typeKeyboard="numeric"
            onPressEnter={() => handleSubmit()}
          />
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClienteCelular;
